// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"f7c64092","213":"eaadc2d9","304":"5e98e083","455":"94229d01","941":"a619b7b2"}[chunkId] + ".chunk.js";
};